import { Component, AfterViewInit, ElementRef, EventEmitter, Input, Output, OnInit, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

import { BaseFilterCollapse, BaseFilterCollapseService } from '../../../core';
import { ClassificacaoFilter } from './classificacao-filter';
import { ClassificacaoFilterStorageService } from './classificacao-filter-storage.service';
import { classificacaoSituacoes, classificacaoAtiva } from '../classificacao-situacao';

@Component({
    selector: 'sgt-classificacao-filter',
    templateUrl: './classificacao-filter.component.html',
    styleUrls: ['./classificacao-filter.component.less']
})
export class ClassificacaoFilterComponent implements BaseFilterCollapse, OnInit, AfterViewInit, OnChanges, OnDestroy {
    @Input() filter: ClassificacaoFilter;

    filterPsqSubscription: Subscription;
    isFilterInitializing = false;
    isFilterInitialized = false;
    @Output() filterInitialized = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();


    // Filter collapse
    @Input() isCollapsedInDefault = false;
    isCollapsedIn = false;
    @ViewChild('filterCollapse') filterCollapse: ElementRef;
    collapseIcon = 'fas fa-caret-down';

    isFirstChangeFilterPsq = true;
    @ViewChild('filterPsq', {static: true}) filterPsq: NgModel;

    /** Situações */
    situacoes = classificacaoSituacoes;

    // Multiselects
    isFirstChangeTiposClassificacoesMultiselect = true;

    constructor(private baseFilterCollapseService: BaseFilterCollapseService,
                private classificacaoFilterStorageService: ClassificacaoFilterStorageService) { }


    ngOnInit() {
        // Aplicando o filtro salvo no storage
        this.classificacaoFilterStorageService.applyFilter(this.filter);
        // Iniciando filtro
        this.initFilter();
    }

    ngAfterViewInit() {
        if (!this.isCollapsedInDefault) {
            jQuery(this.filterCollapse.nativeElement).css('display', 'none');
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isCollapsedInDefault') {
                if (changes[propName].isFirstChange()) {
                    setTimeout(() => {
                        this.isCollapsedIn = changes[propName].currentValue;
                    }, 100);
                }
            }
        }
    }

    /** Inicializa o filtro */
    private initFilter() {
        this.isFilterInitializing = true;
        this.isFilterInitialized = false;

        // Setando os filtros padrões
        this.setDefaultFilters();
        // Filter de pesquisa
        this.subscribeToFilterPsq();

        this.isFilterInitializing = false;
        this.isFilterInitialized = true;
        this.filterInitialized.emit();
    }

    /** Seta os filtros padrões */
    private setDefaultFilters() {
        this.filter.situacao = classificacaoAtiva.id;
    }

    // Realiza o subscribe nas alterações feitas no input do filtro da pesquisa
    private subscribeToFilterPsq() {
        this.filterPsqSubscription = this.filterPsq.valueChanges
            .pipe(
                debounceTime(1000), // Dando um debounce de 1000ms para emitir a alteração
                map(emittedValue => emittedValue?.trim()),
                distinctUntilChanged()
            )
            .subscribe(() => {
                if (this.isFirstChangeFilterPsq) {
                    this.isFirstChangeFilterPsq = false;
                    return;
                }

                if (this.filter.filterPsq?.trim().length > 0) {
                    this.filter.isFilterDirty = true;
                }

                this.filterChange.emit();
            });
    }

    /** Emite evento de alteração no filtro para atualizar a pesquisa */
    refresh() {
        this.close();
        this.filterChange.emit();
    }

    /** Limpa o filtro e atualiza a pesquisa */
    clear() {
        // Removendo os filtros
        this.baseFilterCollapseService.clear(this);
        // Setando os filtros padrões
        this.setDefaultFilters();

        this.refresh();
    }

    /** Abre/Fecha o filtro */
    toggleCollapse() {
        this.baseFilterCollapseService.toggleCollapse(this);
    }

    /** Abre o filtro */
    open() {
        this.baseFilterCollapseService.open(this);
    }

    /** Fecha o filtro */
    close() {
        this.baseFilterCollapseService.close(this);
    }


    /** Ao alterar os tipos de classificações */
    onChangeTiposClassificacoes() {
        if (this.isFirstChangeTiposClassificacoesMultiselect) {
            this.isFirstChangeTiposClassificacoesMultiselect = false;
            return;
        }
        this.filterChange.emit();
    }

    /** Ao alterar os cadastros */
    onChangeCadastros() {
        this.filterChange.emit();
    }

    /** Ao alterar a situação */
    onChangeSituacao(situacao: number) {
        this.filter.situacao = situacao;
        this.filterChange.emit();
    }

    /** Ao alterar os KPIs */
    onChangeCrossSells() {
        this.filterChange.emit();
    }


    ngOnDestroy() {
        this.filterPsqSubscription?.unsubscribe();
    }
}
